import React, { Component } from 'react';
import Message from './Messages'

class MessageList extends Component {

  componentDidUpdate(prevProps, prevState) {
    const diff = this.scrollList.scrollTop - this.scrollTop;
    if(this.scrollList.scrollHeight - (this.scrollList.scrollTop + diff) < 320) {
      this.scrollList.scrollTop = this.scrollList.scrollHeight
    } 
    this.scrollTop = this.scrollList.scrollTop;
  }

  componentDidMount() {
    this.scrollList.scrollTop = this.scrollList.scrollHeight;
  }

  handleScroll = (e) => {
    const top =  e.target.scrollTop;
    if( top == 0 ) {
      this.props.loadPreviousMessages();
    }
  }

  render () {
    return (
      <div className="sc-message-list" ref={el => this.scrollList = el} onScroll={this.handleScroll}>
        {this.props.messages.map((message, i) => {
          return <Message message={message} key={i} userId={this.props.userId} optionList={this.props.optionList}/>
        })}
      </div>)
  }
}

export default MessageList